// 资源类型名名称,用户页面显示
export const typeName = {
  ab: '古籍文献',
  db: '数字古籍',
  ds: '散见史料',
  ir: '图片资源',
  vr: '视频资源',
  yanhua: '岩画',
  moyatike: '摩崖题刻',
  beike: '碑刻',
  shidiao: '石雕'
}
